import styled from 'styled-components';
import { ApButtonMain } from '@alixpartners/ui-components';
import { grey200, grey150, brandColors } from 'styles/colors';
import { Checkbox as UnstyledCheckbox } from 'components/CheckboxGroup';
import { Bar } from 'components/CheckboxGroup/styles';

export const DROPDOWN_MAX_WIDTH = 544;

export const ButtonMain = styled(ApButtonMain)`
	width: 100%;
`;

export const ActionsWrapper = styled.div`
	padding: 9px 32px;
	border-top: 1px solid ${grey200};
	justify-content: space-between;
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const ButtonWrapper = styled.div`
	justify-content: space-between;
	display: flex;
	width: 100%;
`;

export const ListSeparator = styled.div`
	background: ${grey150};
	height: 1px;
	margin: 0 12px 6px;
`;

export const SearchInputWrapper = styled.div`
	display: flex;

	& > div:last-child {
		flex: 1;
	}

	padding: 8px 32px;
`;

export const Checkbox = styled(UnstyledCheckbox)`
	height: 40px;

	svg {
		min-width: 1em;
	}

	${Bar} {
		padding: 8px;

		& > span {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
`;

export const SingleWidthContainerInner = styled.div`
	overflow: auto;
`;

export const ButtonLink = styled.span`
	font-size: 13px;
	text-decoration: underline;
	color: ${brandColors.green};
	cursor: pointer;
	margin-right: 16px;
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 19px;
`;

export const ButtonLinkWrapper = styled.span`
	display: flex;
	padding: 7px 32px;
`;

export const ContainerInner = styled.div`
	overflow-y: auto;
	margin: 0 32px;
`;

export const LoaderWrapper = styled.div`
	width: 30%;
	display: flex;
	justify-content: flex-end;
	align-items: center;

	& > div {
		width: 30%;
	}
`;
